/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { IconCTAComponentEditor } from "cms/components/components/icon-cta/edit";
import { IconCTAComponentDisplay } from "cms/components/components/icon-cta/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const IconCTAComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <IconCTAComponentDisplay />,
        editComponent: <IconCTAComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

IconCTAComponent.displayName = "IconCTAComponent";
export { IconCTAComponent };
